import React from 'react';
import { withRouter } from 'react-router';
import { getSearch } from 'Utils/specialAccess';
import { Link as ReactRouterLink } from 'react-router-dom';

const Link = ({ to, location, match, history, ...rest }) => {
  const search = getSearch(location);
  const linkTo = search ? { pathname: to, search } : to;
  return <ReactRouterLink {...rest} to={linkTo} />;
};

export default withRouter(Link);
